import React from 'react';
import { Github, Linkedin, Mail, Phone, MapPin, ExternalLink, Download, User, Code, GraduationCap } from "lucide-react"
import ThemeToggle from "./ThemeToggle"
import HeroIllustration from "./HeroIllustration"

const Portfolio = () => {
  const projects = [
    {
      title: "Fake News Detector Web App",
      description: "A lightweight and intelligent web application that detects whether a news article is Real or Fake, using a machine learning model trained on real-world data.",
      image: "/FND.png",
      tech: ["Python", "Scikit-Learn", "Streamlit", "Joblibs","Pandas"],
      github: "https://github.com/vedsneh/Fake_News_Detector",
      live: "https://fakenewsdetector-kgvvzfudxhswo7prmaukc6.streamlit.app/",
    },
    {
      title: "DriveTune",
      description: "DriveTune is a smart web app that detects your emotions using your webcam and plays songs on Spotify that match your mood — a perfect co-pilot for your drive or downtime.",
      image: "/DT.png",
      tech: ["TensorFlow", "Keras", "Python", "Streamlit"],
      github: "https://github.com/vedsneh/DriveTune",
      live: "#",
    },
    {
      title: "Movie Recommender System",
      description: "It suggests movies similar to the one you select, fetching movie posters dynamically from The Movie Database (TMDb) API.",
      image: "/MRS.png",
      tech: ["Python", "Streamlit", "Pandas","Pickle","gdown"],
      github: "https://github.com/vedsneh/movie-recommender-clean",
      live: "https://movie-recommender-clean-3e35tljumqurxvs7kprujv.streamlit.app/",
    },
    {
      title: "Read_Gist",
      description: "Read_Gist is a lightweight Chrome extension that uses AI to intelligently summarize entire webpages. With just one click, get a concise gist of any article, blog, or web content — directly in your browser.",
      image: "/CT.png",
      tech: ["JavaScript", "Chrome Extension APIs", "Google Gemini Pro APIs","HTML/CSS"],
      github: "https://github.com/vedsneh/Read_Gist",
      live: "#",
    },
    {
      title: "Saransh AI",
      description: "SaranshAI is a simple yet powerful tool designed to extract meaningful summaries from YouTube videos.",
      image: "/SAI.png",
      tech: ["Python", "OpenAI Whisper", "Huggong Face Transformers","Streamlit", "FPDF","yt-dlp"],
      github: "https://github.com/vedsneh/SaranshAI",
      live: "#",
    },
  ]

  const technicalSkills = [
    "React.js",
    "Node.js",
    "Python",
    "MongoDB",
    "Figma",
    "C++",
    "Data Structures and Algortihms",
    "HTML",
    "SQL",
    "Tailwind CSS",
    "GitHub"
  ]

  const softSkills = ["Leadership", "Problem Solving", "Communication", "Team Work", "Time Management"]

  const leadershipPositions = [
    {
      title: "Vice President",
      organization: "MMMUT Reso",
      period: "2025 - Present",
      description:
        "Driving cross-functional coordination and strategic decision-making to scale MMMUT Reso’s impact across the student community.",
    },
    {
      title: "Treasurer",
      organization: "Coders & Developers Club",
      period: "2025 - Present",
      description:
        "Managing club finances responsibly while supporting events and initiatives with transparent budgeting.",
    },
    {
      title: "Content Moderation & Compliance Lead",
      organization: "MMMUT Reso",
      period: "2024 - 2025",
      description:
        "Oversaw content quality and compliance, ensuring accuracy, clarity, and adherence to platform standards.",
    },
    {
      title: "Executive Member",
      organization: "Coders & Developers Club",
      period: "2024 - 2025",
      description:
        "Contributed to successful event execution and club operations through consistent coordination and support.",
    },
  ]

  return (
    <div className="portfolio">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-content">
            <div className="nav-logo">Portfolio</div>
            <div className="nav-items">
              <div className="nav-links">
                <a href="#home" className="nav-link">
                  Home
                </a>
                <a href="#about" className="nav-link">
                  About
                </a>
                <a href="#projects" className="nav-link">
                  Projects
                </a>
                <a href="#experience" className="nav-link">
                  Experience
                </a>
                <a href="#contact" className="nav-link">
                  Contact
                </a>
              </div>
              <ThemeToggle />
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero-section">
        <div className="hero-bg">
          <div className="hero-bg-gradient"></div>
          <div className="hero-bg-circle hero-bg-circle-1"></div>
          <div className="hero-bg-circle hero-bg-circle-2"></div>
        </div>

        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Hi, I'm <span className="gradient-text">Sneha Pandey</span>
              </h1>

              <div className="hero-subtitle">
                <p className="hero-role">
                  Web Developer & <span className="text-primary">AI/ML Enthusiast</span>
                </p>
                <p className="hero-description">
                  I enjoy building clean, responsive websites and exploring Artificial Intelligence and Machine Learning.
Always curious, always learning.
                </p>
              </div>

              <div className="hero-actions">
                <a
    href="https://drive.google.com/file/d/13QGbESY-hDOOnqdqUlLwT5_KIfLxDURg/view?usp=sharing" // Adjust path if needed
    download
    className="btn btn-outline btn-lg"
  >
                  <Download className="btn-icon" />
                  Download Resume
                </a>
              </div>

              <div className="hero-social">
                <span className="social-label">Follow me:</span>
                <div className="social-links">
                  <a href="https://github.com/vedsneh" className="social-link">
                    <Github className="social-icon" />
                  </a>
                  <a href="https://www.linkedin.com/in/sneha-pandey-1a0535294/" className="social-link">
                    <Linkedin className="social-icon" />
                  </a>
                  <a href="mailto:snehapandey.ved2005@gmail.com" className="social-link">
                    <Mail className="social-icon" />
                  </a>
                </div>
              </div>

              <div className="hero-coding">
                <span className="coding-label">Coding Profiles:</span>
                <div className="coding-links">
                  <a href="https://leetcode.com/u/Sneha_Pandey95/" className="coding-link">
                    LeetCode
                  </a>
                  <a href="https://www.geeksforgeeks.org/user/snehapanfchz/" className="coding-link">
                    GeeksForGeeks
                  </a>
                  <a href="https://codeforces.com/profile/snehapandey.ved2005" className="coding-link">
                    CodeForces
                  </a>
                  <a href="https://www.hackerrank.com/profile/snehapandey_ved1" className="coding-link">
                    HackerRank
                  </a>
                </div>
              </div>
            </div>

            <div className="hero-illustration">
              <HeroIllustration />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">About Me</h2>
            <p className="section-subtitle">
              I'm a Web Developer with a growing interest in AI and Machine Learning.
I enjoy building responsive, functional interfaces from ideas.
Always curious, always learning — exploring what’s next in tech.
            </p>
          </div>

          <div className="about-content">
            <div className="about-text">
              <p className="about-paragraph">
                I'm a Web Developer with a growing interest in AI and Machine Learning. I enjoy creating responsive, easy-to-use interfaces with a focus on clarity and functionality. Writing clean, maintainable code is something I prioritize in every project.
              </p>
              <p className="about-paragraph">
                Lately, I've been exploring ways to blend practical web solutions with emerging technologies. I'm focused on learning steadily, improving my skills, and building things that serve a purpose.
              </p>

              <div className="about-stats">
                <div className="stat">
                  <div className="stat-number">7+</div>
                  <div className="stat-label">Projects Built</div>
                </div>
                <div className="stat">
                  <div className="stat-number">300+</div>
                  <div className="stat-label">DSA Questions Solved</div>
                </div>
              </div>
            </div>

            <div className="about-skills">
              <div className="skills-group">
                <h3 className="skills-title">
                  <Code className="skills-icon" />
                  Technical Skills
                </h3>
                <div className="skills-list">
                  {technicalSkills.map((skill) => (
                    <span key={skill} className="skill-badge skill-badge-secondary">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              <div className="skills-group">
                <h3 className="skills-title">
                  <User className="skills-icon" />
                  Soft Skills
                </h3>
                <div className="skills-list">
                  {softSkills.map((skill) => (
                    <span key={skill} className="skill-badge skill-badge-outline">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section id="projects" className="projects-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Featured Projects</h2>
            <p className="section-subtitle">A showcase of my recent work and personal projects</p>
          </div>

          <div className="projects-grid">
            {projects.map((project, index) => (
              <div key={index} className="project-card">
                <div className="project-image">
                  <img src={project.image || "/placeholder.svg"} alt={project.title} />
                </div>
                <div className="project-content">
                  <div className="project-header">
                    <h3 className="project-title">{project.title}</h3>
                    <div className="project-links">
                      <a href={project.github} className="project-link">
                        <Github className="project-link-icon" />
                      </a>
                      <a href={project.live} className="project-link">
                        <ExternalLink className="project-link-icon" />
                      </a>
                    </div>
                  </div>
                  <p className="project-description">{project.description}</p>
                  <div className="project-tech">
                    {project.tech.map((tech) => (
                      <span key={tech} className="tech-badge">
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section id="experience" className="experience-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Experience & Leadership</h2>
            <p className="section-subtitle">My professional journey and positions of responsibility</p>
          </div>

          <div className="experience-content">
            <div className="leadership-section">
              <h3 className="experience-title">
                <GraduationCap className="experience-icon" />
                Leadership & Responsibilities
              </h3>
              <div className="experience-list">
                {leadershipPositions.map((position, index) => (
                  <div key={index} className="experience-card">
                    <div className="experience-header">
                      <h4 className="experience-role">{position.title}</h4>
                      <div className="experience-meta">
                        <span className="experience-org">{position.organization}</span>
                        <span className="experience-period">{position.period}</span>
                      </div>
                    </div>
                    <p className="experience-description">{position.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Resume Section */}
      <section className="resume-section">
        <div className="section-container">
          <h2 className="section-title">Resume</h2>
          <p className="section-subtitle">
            Download my resume to learn more about my background and experience
          </p>

          <div className="resume-card">
            <div className="resume-icon">
              <Download className="download-icon" />
            </div>
            <div className="resume-content">
              <h3 className="resume-title">Sneha Pandey - Resume</h3>
              <p className="resume-description">Complete overview of my skills, experience, and achievements</p>
              <a
    href="https://drive.google.com/file/d/13QGbESY-hDOOnqdqUlLwT5_KIfLxDURg/view?usp=sharing" // Adjust path if needed
    download
    className="btn btn-primary btn-lg">
  
                <Download className="btn-icon" />
                Download PDF Resume
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Connect with me</h2>
            <p className="section-subtitle">Open to internships and collaborative projects.</p>
          </div>

          <div className="contact-content">
            <div className="contact-info">
              <div className="contact-group">
                <h3 className="contact-title">Contact Information</h3>
                <div className="contact-list">
                  <div className="contact-item">
                    <Mail className="contact-icon" />
                    <span>snehapandey.ved2005@gmail.com</span>
                  </div>
                  <div className="contact-item">
                    <Phone className="contact-icon" />
                    <span>+91 8171279390</span>
                  </div>
                  <div className="contact-item">
                    <MapPin className="contact-icon" />
                    <span>Uttar Pradesh, India</span>
                  </div>
                </div>
              </div>

              <div className="contact-group">
                <h3 className="contact-title">Follow Me</h3>
                <div className="contact-social">
                  <a href="https://github.com/vedsneh" className="contact-social-link">
                    <Github className="contact-social-icon" />
                  </a>
                  <a href="https://www.linkedin.com/in/sneha-pandey-1a0535294/" className="contact-social-link">
                    <Linkedin className="contact-social-icon" />
                  </a>
                  <a href="mailto:snehapandey.ved2005@gmail.com" className="contact-social-link">
                    <Mail className="contact-social-icon" />
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-form-card">
              <div className="contact-form-header">
                <h3 className="contact-form-title">Send me a message</h3>
                <p className="contact-form-subtitle">I'll get back to you as soon as possible</p>
              </div>
              <form className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">First Name</label>
                    <input type="text" className="form-input" placeholder="First Name" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Last Name</label>
                    <input type="text" className="form-input" placeholder="Last Name" />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-input" placeholder="name@example.com" />
                </div>
                <div className="form-group">
                  <label className="form-label">Subject</label>
                  <input type="text" className="form-input" placeholder="Project Inquiry" />
                </div>
                <div className="form-group">
                  <label className="form-label">Message</label>
                  <textarea className="form-textarea" placeholder="Tell me about your project..." rows="5"></textarea>
                </div>
                <button type="submit" className="btn btn-primary btn-full">
                  <Mail className="btn-icon" />
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-info">
              <div className="footer-name">Sneha Pandey</div>
              <p className="footer-role">Web Developer & AI/ML Enthusiast</p>
            </div>

            <div className="footer-links">
              <a href="#home" className="footer-link">
                Home
              </a>
              <a href="#about" className="footer-link">
                About
              </a>
              <a href="#projects" className="footer-link">
                Projects
              </a>
              <a href="#contact" className="footer-link">
                Contact
              </a>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Sneha Pandey. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Portfolio
